import React from 'react';
import PropTypes from 'prop-types';

const CheckIfAnyData = ({ children, dataSize, message }) => {
  return (
    <div>
      {dataSize > 0 ? children : <div className={ 'trade-post__no-data' }>{message}</div>}
    </div>
  );
};

CheckIfAnyData.propTypes = {
  dataSize: PropTypes.number.isRequired,
  message: PropTypes.string
};

CheckIfAnyData.defaultProps = {
  message: 'There are no data'
};

export default CheckIfAnyData;



// WEBPACK FOOTER //
// ./app/components/shared/CheckIfAnyData.jsx